import { withStyles } from '@mui/styles';
import AdminPageBase from './AdminPageBase';
import styles from './styles';

const Styled = withStyles(styles)(AdminPageBase);

export default Styled;
